import React, { useEffect, useState } from 'react';
import { styles } from './Style';
import Line from '../../../assets/svg/Line';
import { featureDescriptions, formatPrice, getEnabledFeatures } from '../../../utlites';
import { FiCheck } from 'react-icons/fi';

export default function ThirdStep({ formik, onSelectPlan, submitLoading,setPlanId=()=>{},setBillingCycleText=()=>{} }) {
    const [billingCycle, setBillingCycle] = useState('monthly');
    const [selectedPlan, setSelectedPlan] = useState(formik.values.selectedPlan || null);
    const [loading, setLoading] = useState(false);
    const [pricingPlans, setPricingPlans] = useState([])
    const [loadingPlanId, setLoadingPlanId] = useState(null);

    const handlePlanSelect = (plan) => {
        setSelectedPlan(plan.id);
        setPlanId(plan.id);
        setLoadingPlanId(plan.id);
        setBillingCycleText(billingCycle);
        formik.handleSubmit();
    };

    const getCurrentPrice = (plan) => {
        if (plan.month_price === null) return null;
        return billingCycle === 'monthly' ? formatPrice(plan.price_monthly) : formatPrice(plan.price_yearly);
    };

    const getAllPlans = async () => {
        try {
            setLoading(true);
            const res = await fetch(`${process.env.REACT_APP_BASE_URL}/subscribe_company/enabled`, {
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    "appname": "LimeTi",
                }
            });
            const data = await res.json();
            console.log("plan && Price : ", data);
            if (data.success === true && Array.isArray(data?.data)) {
                setPricingPlans(data.data);
            }
        } catch (error) {
            console.log(error);
            setPricingPlans([]);
        } finally {
            setLoading(false)
        }
    }


    useEffect(() => {
        getAllPlans();
    }, []);

    if (loading) {
        return (
            <div style={{ display: "flex", justifyContent: "center", padding: "20px" }}>
                <div className="spinner-border" role="status">
                    <span className="sr-only"></span>
                </div>
            </div>
        )
    }

    return (
        <div style={styles.container}>

            {/* Header with Billing Toggle */}
            <div style={styles.header}>
                <div style={styles.billingToggle}>
                    <button
                        type="button"
                        onClick={() => setBillingCycle('monthly')}
                        style={{
                            ...styles.toggleButton,
                            ...(billingCycle === 'monthly' ? styles.toggleButtonActive : {})
                        }}
                    >
                        Monthly
                    </button>
                    <button
                        type="button"
                        onClick={() => setBillingCycle('yearly')}
                        style={{
                            ...styles.toggleButton,
                            ...(billingCycle === 'yearly' ? styles.toggleButtonActive : {})
                        }}
                    >
                        Yearly
                    </button>
                </div>
            </div>

            {/* Error  */}
            {
                !selectedPlan && formik.errors.selectedPlan && (
                    <div style={{ display: "flex", justifyContent: "center" }}>
                        <span style={{ ...styles.badgeText, color: "red" }}>Plan is required please click in the plan</span>
                    </div>
                )
            }

            {/* No Credit Card Badge */}
            <div style={styles.badge}>
                <div style={styles.noCreait}>
                    <span style={styles.badgeText}>No credit card required</span>
                </div>
            </div>

            {/* Pricing Cards - Horizontal Scroll */}
            <div style={styles.scrollContainer}>
                <div style={styles.pricingGrid}>
                    {pricingPlans.map((plan) => {
                        const isPopularOrSelected = plan?.is_recommended;

                        return (
                            <div
                                key={plan.id}
                                style={{
                                    ...styles.card,
                                    backgroundColor: plan?.is_recommended ? '#7bb321' : "#fff"
                                }}
                            >
                                {plan.is_recommended && (
                                    <div style={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                                        <div style={styles.popularBadge}>MOST POPULAR</div>
                                    </div>
                                )}

                                <div style={styles.cardContent}>
                                    {/* Price */}
                                    <div style={styles.priceSection}>
                                        {getCurrentPrice(plan) !== null ? (
                                            <>
                                                <span style={{
                                                    ...styles.price,
                                                    color: isPopularOrSelected ? '#fff' : '#1a1a1a'
                                                }}>
                                                    {getCurrentPrice(plan)}
                                                </span>
                                                <span style={{
                                                    ...styles.period,
                                                    color: isPopularOrSelected ? '#fff' : '#666'
                                                }}>
                                                    /{billingCycle === "monthly" ? "Monthly" : "Yearly"}
                                                </span>
                                            </>
                                        ) : (
                                            <span style={{
                                                ...styles.price,
                                                color: isPopularOrSelected ? '#fff' : '#1a1a1a'
                                            }}>
                                                {plan.priceLabel}
                                            </span>
                                        )}
                                    </div>

                                    {/* Employees */}
                                    <p style={{
                                        ...styles.employees,
                                        color: isPopularOrSelected ? '#fff' : '#666'
                                    }}>
                                        Up to {plan.employee_limit} employees
                                    </p>

                                    {/* free_trial_days */}
                                    <p style={{
                                        ...styles.employees,
                                        color: isPopularOrSelected ? '#fff' : '#666'
                                    }}>
                                        {plan.free_trial_days} Free Days
                                    </p>

                                    {/* Plan Name */}
                                    <h3 style={{
                                        ...styles.planName,
                                        color: isPopularOrSelected ? '#fff' : '#1a1a1a'
                                    }}>
                                        {plan.name}
                                    </h3>

                                    {/* Description */}
                                    <p style={{
                                        ...styles.description,
                                        color: isPopularOrSelected ? '#fff' : '#666'
                                    }}>
                                        {plan.description}
                                    </p>

                                    {/* Features plan?.features?.permission || {}*/}
                                    <div style={styles.featuresContainer}>
                                        {Array.isArray(getEnabledFeatures(plan?.features?.permission || {})) && getEnabledFeatures(plan?.features?.permission || {}).length > 0 && (
                                            getEnabledFeatures(plan?.features?.permission || {}).map((feature, index) => (
                                                <div key={index} style={styles.featureItem}>
                                                    <div style={{
                                                        ...styles.checkIcon,
                                                        backgroundColor: isPopularOrSelected ? '#ffffff30' : '#D1FAE5'
                                                    }}>
                                                        <FiCheck
                                                            size={14}
                                                            color={isPopularOrSelected ? '#fff' : '#10B981'}
                                                        />
                                                    </div>
                                                    <p style={{
                                                        ...styles.featureText,
                                                        color: isPopularOrSelected ? '#fff' : '#374151'
                                                    }}>
                                                        {featureDescriptions[feature]}
                                                    </p>
                                                </div>
                                            ))
                                        )}
                                    </div>


                                    {/* Button */}
                                    <button
                                        type="button"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handlePlanSelect(plan);
                                        }}
                                        disabled={submitLoading && loadingPlanId !== plan.id}
                                        style={{
                                            ...styles.planButton,
                                            backgroundColor: isPopularOrSelected ? '#fff' : '#7bb321',
                                            color: isPopularOrSelected ? '#7bb321' : '#fff'
                                        }}
                                    >
                                        {
                                            submitLoading && loadingPlanId === plan.id ?
                                                <div style={{ display: "flex", justifyContent: "center", }}>
                                                    <div class="spinner-border" role="status">
                                                        <span class="sr-only"></span>
                                                    </div>
                                                </div>
                                            : 
                                                "Start Free Trail"
                                        }
                                    </button>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            

            {/* Decorative Dots */}
            <div style={{ ...styles.dot, top: '1%', left: '5%', backgroundColor: '#ff6b6b' }} />
            <div style={{ ...styles.dot, top: '1%', right: '8%', backgroundColor: '#7bb321' }} />
            <div className="position-absolute" style={{ right: "90px", top: "-180px" }}>
                <Line />
            </div>
        </div>
    );
}